<template>
  <div>
    <v-row>
      <v-col class="text-subtitle-2 gray--text text--lighten-1">
        Período de afastamento
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          :value="medicalLeaveStart"
          @input="triggerUpdateAndSaveFor('medicalLeaveStart', $event)"
          placeholder=" "
          label="Inicio"
          type="date"
          dense
          outlined
          clearable
          background-color="white"
          :hide-details="!errors.medicalLeaveStart"
          :error-messages="errors.medicalLeaveStart"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          :value="medicalLeaveEnd"
          @input="triggerUpdateAndSaveFor('medicalLeaveEnd', $event)"
          placeholder=" "
          label="Fim"
          type="date"
          dense
          outlined
          clearable
          background-color="white"
          :hide-details="!errors.medicalLeaveEnd"
          :error-messages="errors.medicalLeaveEnd"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-combobox
          :value="serviceType"
          @input="triggerUpdateAndSaveFor('serviceType', $event)"
          placeholder=" "
          label="Tipo de serviço"
          dense
          outlined
          hide-details
          :items="serviceTypes"
          item-text="name"
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-textarea
          :value="notes"
          @input="triggerUpdateAndSaveFor('notes', $event)"
          label="Notas"
          outlined
          hide-details
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-select
          :value="selectedActiveDiagnosticHypotheses"
          @input="
            triggerUpdateAndSaveFor(
              'selectedActiveDiagnosticHypotheses',
              $event
            )
          "
          placeholder=" "
          label="CID ativas"
          :items="activeDiagnosticHypotheses"
          item-text="cid.codeDescription"
          dense
          outlined
          hide-details
          clearable
          multiple
          chips
          small-chips
          return-object
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-select
          :value="selectedInactiveDiagnosticHypotheses"
          @input="
            triggerUpdateAndSaveFor(
              'selectedInactiveDiagnosticHypotheses, $event'
            )
          "
          placeholder=" "
          label="CID inativas"
          :items="inactiveDiagnosticHypotheses"
          item-text="cid.codeDescription"
          dense
          outlined
          hide-details
          clearable
          multiple
          chips
          small-chips
          return-object
          background-color="white"
          :disabled="disableEdit"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MedicalCertificateFormAfastamentoFields",
  props: {
    medicalLeaveStart: {
      type: String,
      required: false,
    },
    medicalLeaveEnd: {
      type: String,
      required: false,
    },
    serviceType: {
      type: Object,
      required: false,
    },
    notes: {
      type: String,
      required: false,
    },
    selectedActiveDiagnosticHypotheses: {
      type: Array,
      required: true,
    },
    selectedInactiveDiagnosticHypotheses: {
      type: Array,
      required: true,
    },
    disableEdit: {
      type: Boolean,
      required: true,
    },
    serviceTypes: {
      type: Array,
      required: true,
    },
    activeDiagnosticHypotheses: {
      type: Array,
      required: true,
    },
    inactiveDiagnosticHypotheses: {
      type: Array,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
  methods: {
    triggerUpdateAndSaveFor(syncedProp, value) {
      this.$emit(`update:${syncedProp}`, value);
      this.$emit("save");
    },
  },
};
</script>

<style scoped></style>
